export default function ServiceUnavailablePage() {
  return (
    <div>
      <h1>503: Servicio no disponible</h1>
      <p>Estamos realizando tareas de mantenimiento. Por favor, vuelve a intentarlo en unos minutos.</p>
    </div>
  )
}
